import endpoints from '../../../config/endpoints';

export default  [{
	name: 'affiliates',
	title: 'Affiliates',
	placeholder: 'Add affiliates',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.AFFILIATES
	}
}, {
	name: 'cpa',
	title: 'CPA',
	placeholder: 'Add CPA',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'provided',
		source: [
			{ value: 'everad', label: 'Everad' },
			{ value: 'rocket', label: 'Rocket' }
		]
	}
}, {
	name: 'affiliate_countries',
	title: 'Affiliate country',
	placeholder: 'Add affiliate country',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.AFFILIATE_COUNTRIES
	}
}, {
	name: 'offers',
	title: 'Offers',
	placeholder: 'Add offers',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.OFFERS
	}
}, {
	name: 'landings',
	title: 'Landings',
	placeholder: 'Add landings',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.LANDINGS
	}
}, {
	name: 'transit_domains',
	title: 'Transit domains',
	placeholder: 'Add transit domains',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: false,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.TRANSIT_DOMAINS
	}
}, {
	name: 'landing_domains',
	title: 'Landing domains',
	placeholder: 'Add landing domains',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: false,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.LANDING_DOMAINS
	}
}, {
	name: 'transits',
	title: 'Transits',
	placeholder: 'Add transits',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.TRANSITS
	}
}, {
	name: 'countries',
	title: 'Countries',
	placeholder: 'Add countries',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.COUNTRIES
	}
}, {
	name: 'cities',
	title: 'Cities',
	placeholder: 'Add cities',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.CITIES
	}
}, {
	name: 'campaigns',
	title: 'Campaigns',
	placeholder: 'Add campaigns',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.CAMPAIGNS
	}
}, {
	name: 'campaign_types',
	title: 'Campaign types',
	placeholder: 'Add campaign types',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'static',
		source: 'root.lists.campaign-types'
	}
}, {
	name: 'traffic_types',
	title: 'Traffic types',
	placeholder: 'Add traffic types',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'static',
		source: 'root.lists.traffic-types'
	}
}, {
	name: 'sids1',
	title: 'sids1',
	placeholder: 'Add sids1',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.SIDS1
	}
}, {
	name: 'sids2',
	title: 'sids2',
	placeholder: 'Add sids2',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.SIDS2
	}
}, {
	name: 'sids3',
	title: 'sids3',
	placeholder: 'Add sids3',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.SIDS3
	}
}, {
	name: 'sids4',
	title: 'sids4',
	placeholder: 'Add sids4',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.SIDS4
	}
}, {
	name: 'sids5',
	title: 'sids5',
	placeholder: 'Add sids5',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.SIDS5
	}
}, {
	name: 'managers',
	title: 'Managers',
	placeholder: 'Add managers',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.MANAGERS
	}
}, {
	name: 'sale_model',
	title: 'Sale model',
	placeholder: 'Add sale model',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.SALEMODELS
	}
}, {
	name: 'referer_types',
	title: 'Referer types',
	placeholder: 'Add referer types',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'static',
		source: 'root.lists.referer-types'
	}
}, {
	name: 'referer_domains',
	title: 'Referer domains',
	placeholder: 'Add referer domains',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: true,
	options: {
		type: 'dynamic',
		source: endpoints.STATISTICS.FILTERS.REFERER_DOMAINS
	}},
{
	name: 'lead_types',
	title: 'Lead type',
	placeholder: 'Add lead type',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: false,
	options: {
		type: 'static',
		source: 'root.lists.conversion-types'
	}
}, {
	name: 'affiliate_landing_domains',
	title: 'Affiliate landing domains',
	placeholder: 'Enter affiliate landing domains',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: false,
	options: {
		type: 'dynamic',
		source: endpoints.LOOKUPS.AFFILIATE_LANDING_DOMAINS
	}
}, {
	name: 'offer_tags',
	title: 'Offer tags',
	placeholder: 'Offer tags',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: false,
	options: {
		type: 'dynamic',
		source: endpoints.LOOKUPS.OFFER_TAGS
	}
}, {
	name: 'status_changed_at',
	title: 'Status changed at',
	placeholder: 'Enter status changed at',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: false,
	options: {
		type: 'dynamic',
		source: endpoints.LOOKUPS.STATUS_CHANGED_AT
	}
}, {
	name: 'traffic_source',
	title: 'Traffic source',
	placeholder: 'Enter traffic sources',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: false,
	options: {
		type: 'static',
		source: 'root.lists.traffic-sources'
	}
}, {
	name: 'approval_type',
	title: 'Approval type',
	placeholder: 'Enter approval types',
	value: [],
	multi: true,
	shouldInverse: false,
	shouldShowInverseControl: false,
	options: {
		type: 'static',
		source: 'root.lists.conversion-approval-types'
	}
}];



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/shared/filters.js